//TODO: this should be in sync with electron version

import { init as initAmplitude, Identify, identify, setGroup, track } from '@amplitude/analytics-browser'
import {
	type EventType,
	type TelemetryAdapter,
	type TelemetryMetadata,
	type CustomDimensions,
	type TelemetryConfig
} from '@/features/telemetry/types'

export function useAmplitudeTelemetryAdapter(
	configOptionGetter: <T extends keyof TelemetryConfig>(key: T) => TelemetryConfig[T] | undefined,
	initialMetadata: TelemetryMetadata
): TelemetryAdapter {
	const apiKey = configOptionGetter('AMPLITUDE_API_KEY')
	let metadata: TelemetryMetadata = initialMetadata

	if (apiKey) {
		initAmplitude(apiKey, undefined, {
			minIdLength: 1
		})

		identifyAmplitudeUser()
	} else {
		console.warn('Missing api key - Amplitude telemetry not initialized.')
	}

	function identifyAmplitudeUser() {
		if (!apiKey) {
			return
		}

		const identifyObj = new Identify()

		identifyObj.set('company', metadata.user?.companyName ?? '')
		identifyObj.set('isTestAccount', metadata.user?.isTestAccount ?? '')
		identifyObj.set('isPartner', metadata.user?.isPartner ?? '')
		identifyObj.set('email', metadata.user?.username ?? '')

		identifyObj.set('saasPlanName', metadata.saasPlan?.name ?? '')
		identifyObj.set('saasPlanId', metadata.saasPlan?.id ?? '')

		setGroup('Company', metadata.user?.companyName ?? '')

		identify(identifyObj, {
			user_id: metadata.user?.id ? String(metadata.user.id) : undefined
		})
	}

	return {
		trackEvent(_type: EventType, name: string, customProperties?: CustomDimensions) {
			if (!apiKey) {
				return
			}

			track(
				name,
				{ ...customProperties },
				{
					app_version: metadata.app?.version,
					user_id: metadata.user?.id ? String(metadata.user.id) : undefined,
					device_id: metadata.app?.installationId
				}
			)
		},

		trackException() {
			// Not tracked in Amplitude adapter
		},

		trackPageView() {
			// Not tracked in Amplitude adapter
		},

		setMetadata(telemetryMetadata: TelemetryMetadata) {
			metadata = telemetryMetadata

			identifyAmplitudeUser()
		},

		startTransaction() {
			// Not used in Amplitude
			return undefined
		}
	}
}
